export default __webpack_public_path__ + "static/media/elixir.1778d4ad.png";